import React from 'react';

interface VendorsIconProps {
  color?: string;
  className?: string;
  width?: number;
  height?: number;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const VendorsIcon: React.FC<VendorsIconProps> = ({
  className = "",
  width = 24,
  height = 24,
  color = 'white'
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M19.8745 17.9995V16C19.8745 14.9645 19.035 14.125 17.9995 14.125H17.1235L11.7959 19.4527C11.3567 19.8918 10.6445 19.8915 10.2051 19.4527C9.76574 19.0133 9.76574 18.3012 10.2051 17.8618L17.2759 10.791C18.0081 10.0588 18.0081 8.87044 17.2759 8.13821L15.8608 6.72464C15.1286 5.99252 13.9417 5.99244 13.2095 6.72464L11.7959 8.13821C11.3566 8.57751 10.6444 8.57744 10.2051 8.13821C9.76574 7.69887 9.76574 6.98673 10.2051 6.54739L11.6187 5.13382C13.2295 3.52294 15.8407 3.52302 17.4517 5.13382L18.8667 6.54739L19.1494 6.86087C20.377 8.36582 20.3813 10.5336 19.1655 12.0449C20.8757 12.5481 22.1245 14.1269 22.1245 16V17.9995C22.1245 20.2777 20.2777 22.1245 17.9995 22.1245H7C6.37868 22.1245 5.875 21.6209 5.875 20.9995C5.87525 20.3784 6.37883 19.8745 7 19.8745H17.9995C19.035 19.8745 19.8745 19.0351 19.8745 17.9995Z" fill={color}/>
      <path d="M9.87451 6C9.87451 4.96447 9.03505 4.125 7.99951 4.125H6C4.96447 4.125 4.125 4.96447 4.125 6V18C4.125 19.0355 4.96447 19.875 6 19.875H7.99951C9.03505 19.875 9.87451 19.0355 9.87451 18V6ZM8.625 16.9995C8.625 17.8968 7.89773 18.6252 7.00049 18.6255C6.15923 18.6255 5.46668 17.9858 5.3833 17.1665L5.37451 16.9995L5.3833 16.834C5.46645 16.0145 6.15907 15.375 7.00049 15.375L7.16602 15.3838C7.98532 15.4669 8.62475 16.1583 8.625 16.9995ZM12.1245 18C12.1245 20.2782 10.2777 22.125 7.99951 22.125H6C3.72183 22.125 1.875 20.2782 1.875 18V6C1.875 3.72183 3.72183 1.875 6 1.875H7.99951C10.2777 1.875 12.1245 3.72183 12.1245 6V18Z" fill={color}/>
    </svg>
  );
}; 